enum UserLocationDatePeriod {
  Day,
  Week,
  Month,
}

export default UserLocationDatePeriod;
